import variable from './variable';

export default variable;
